module.exports = __webpack_public_path__ + "static/img/quality.0d17dd66.png";